import axios from "./AxiosClient";

const url = `/api`;

const AuthService = {
  login: (data) => {
    return axios.post(`${url}/login`, data);
  },
  forgotPassword: (data) => {
    return axios.post(`${url}/forgotpassword`, data);
  },
  resetPassword: (data) => {
    const token = data.token;
    return axios.post(`${url}/resetpassword/${token}`, data);
  },
  setPassword: (data) => {
    return axios.post(`${url}/setNewPassword`, data);
  },

  loggedInUser: () => {
    return axios.get(`${url}/user`);
  },

  logout: () => {
    return axios.post(`${url}/logout`);
  },

  addNewProject: (data) => {
    return axios.post(`${url}/csd/add`, data);
  },

  getAzureData: () => {
    return axios.get(`${url}/ms-login-uri`);
  },

  postAzureData: (data) => {
    return axios.post(`${url}/ms-login`, data);
  },
};

export default AuthService;
